import { strToGender, strToInterests } from '@/_containers';
import {
  booleanQueryToFormConverter,
  currencyInput,
  nullableNumericToNumericStringConverter,
} from '@/_schemas/generic';
import { strToStatus } from '@/_schemas/status-input';

import { strToShirtSizePreference, strToTechPreference } from '../components';
import type { TeamMemberFormSchema, TeamMemberQuerySchema } from '../schemas';

export function teamMemberQueryToForm(data: TeamMemberQuerySchema): TeamMemberFormSchema {
  return {
    ...data,
    id: data.id,
    first_name: data?.first_name ?? '',
    last_name: data?.last_name ?? '',
    biography: data?.biography ?? '',
    job_title: data?.job_title ?? '',

    gender: strToGender(data.gender),
    tech_preference: strToTechPreference(data.tech_preference),
    t_shirt_size: strToShirtSizePreference(data.t_shirt_size),

    personal_email: data.personal_email ?? '',
    work_email: data.work_email ?? '',
    hr_identifier: data.hr_identifier ?? '',
    internal_extension: data.internal_extension ?? '',

    hired_on: data.hired_on ?? '',
    pet_names: data.pet_names ?? '',
    // TODO: fix this
    birthdate: data.birthdate ?? '',

    termination: data.termination ?? '',
    parent: data.parent || null,
    status: strToStatus(data.status ?? ''),
    interests: strToInterests(data.interests),
    children_names: data.children_names ?? '',
    spouse_name: data.spouse_name ?? '',
    w2_withholdings: -1,
    tax_type: data.tax_type ?? '',

    gallery: data.gallery ?? [],

    zoom: nullableNumericToNumericStringConverter(data.zoom),
    freshdesk: nullableNumericToNumericStringConverter(data.freshdesk),
    harvest: nullableNumericToNumericStringConverter(data.harvest),
    gusto: data?.gusto ?? '',

    // Backend may not return this field; keep blank by default.
    lockdown_override_pin: '',

    commission_periods:
      data.commission_periods?.map((p) => ({
        ...p,
        bonus_paid: booleanQueryToFormConverter(p.bonus_paid),
        bonus_amount_paid: currencyInput.queryToFormConverter(p.bonus_amount_paid),
      })) ?? [],
  };
}
